import { Autocomplete, TextField } from "@mui/material";

interface GenericAutocompleteProps<T extends string | number> {
  label: string;
  onChange: (value: T[]) => void;
  optionMap: Map<T, { name: string }>;
  options: T[];
  value: T[];
}

export function GenericAutocomplete<T extends string | number>({
  label,
  options,
  value,
  onChange,
  optionMap,
}: GenericAutocompleteProps<T>) {
  return (
    <Autocomplete<T, true>
      fullWidth
      multiple
      options={options}
      renderInput={(params) => <TextField {...params} label={label} />}
      value={value}
      onChange={(_event, newValue) => onChange(newValue)}
      getOptionLabel={(optionId) => optionMap.get(optionId)?.name || ""}
      getOptionKey={(optionId) => optionId}
    />
  );
}
